module.exports = new __parcel__URL__("NotFound.4cf1886c.svg").toString();